<template>
  <div :class="$style.breadCrumb">
    <span
      v-for="(item, i) in items"
      :key="i"
      :class="item.active && $style.active"
    >
      {{ item.text }}
      <span
        v-if="i!==items.length-1"
        :class="$style.symbol"
      >
        >
      </span>
    </span>
  </div>
</template>

<style lang="scss" module>
.breadCrumb {
  font-size: 1.2rem;
  color: #c5c5c5;
  margin: 8px auto 40px;

  .active {
    color: $color-text;
  }

  .symbol {
    color: #c5c5c5a0;
  }
}
</style>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: null,
    },
  },
};
</script>
